import axios from "axios";
import store from "@/store/store";
import {authService} from '@/modules/auth/services/authService.js'

let HTTP;

HTTP = axios.create({
  baseURL: window.vue_config.VUE_APP_API_URL_GATEWAY + '/v3/',
});

let mockHTTP = null;

const replaceHTTP = (path) => {
  if (!mockHTTP) {
    mockHTTP = axios.create({
      baseURL: path,
      withCredentials: false,
    });
  }
}

const get = (route, params, paramsSerializer = undefined, mock = false) => {
  if (mock) {
    return mockHTTP.get(route, { params, paramsSerializer }).then(res => res.data);
  }
  return HTTP.get(route, { params, paramsSerializer }).then(res => res.data);
};

const post = (route, params, mock = false) => {
  if (mock) {
    return mockHTTP.post(route, params).then(res => res.data);
  }
  return HTTP.post(route, params).then(res => res.data);
};

const put = (route, params, mock = false) => {
  if (mock) {
    return mockHTTP.put(route, params).then(res => res.data);
  }
  return HTTP.put(route, params).then(res => res.data);
};

const patch = (route, params, mock = false) => {
  if (mock) {
    return mockHTTP.patch(route, params).then(res => res.data);
  }
  return HTTP.patch(route, params).then(res => res.data);
};

let remove = (route, params, mock = false) => {
  if (mock) {
    return mockHTTP.delete(route, params).then(res => res.data);
  }
  return HTTP.delete(route, params).then(res => res.data);
};

HTTP.interceptors.request.use(
  config => {
    // Do something before request is sent
    const token = store.getters["auth/token"];
    const staff = store.getters["accountModule/staff"];
    const profile = store.getters["accountModule/profile"];
    const isPermitted = store.getters['accountModule/hasPermission']('has_staff_view');

    config.headers["x-mobile-app"] = store.getters["isMobileApp"];
    config.headers["x-app-name"] = "Frontage";
    if (!config.params){
      config.params = {}
    }

    if (staff && profile && staff.uid != profile.staff.uid){
      config.params.context_staff = staff.uid
    }

    if (isPermitted){
      config.params.teams_view_filter = store.getters["accountModule/teamsViewFilter"]
    }

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    if (config.url.includes('platform/v1/') || config.new_api || config.params.new_api || (config.data && config.data.new_api)) {
      config.baseURL = window.vue_config.VUE_APP_API_URL;
    }

    return config;
  },
  error => {
    // Do something with request error
    return Promise.reject(error);
  }
);

HTTP.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    // Do something with response error
    if (error.response && error.response.status === 401) {
      let resp = await authService.getToken()
      if (resp.success){
        store.commit('auth/saveToken',resp.jwt)
        error.config.headers["Authorization"] = `Bearer ${resp.jwt}`;
        return HTTP(error.config);
      } else {
        authService.logout();
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }
);


export default {
  get,
  post,
  put,
  patch,
  remove,
  replaceHTTP,
};
